module.exports = __webpack_public_path__ + "media/images/haircut/main_image2@2x-d15f0747485d49bfb4b800dc595316f4.jpg";